import type { OpenContext, ApusAssistantApi, WidgetOptions } from "./types.ts";
import { Assistant, VERSION } from "./widget.ts";

export * from "./types.ts";
export { Assistant, VERSION };
/** Công khai vì app chủ nào tự vẽ bong bóng cũng cần đúng bộ escape này. */
export { renderMarkdown, escapeHtml } from "./core/markdown.ts";

/**
 * Dựng trợ lý và gắn vào trang.
 *
 *   const assistant = ApusAssistant.init({
 *     getToken: () => auth.getAccessToken(),
 *     onAction: (a) => router.handle(a),
 *     onOpen:   ({ width }) => setLayoutOffset(width),
 *     onClose:  () => setLayoutOffset(0),
 *   });
 *
 * Gọi trước khi <body> tồn tại vẫn an toàn — việc gắn DOM được hoãn lại đến
 * khi trang sẵn sàng.
 */
export function init(options: WidgetOptions = {}): ApusAssistantApi {
  const assistant = new Assistant(options);
  assistant.markExplicit(Object.keys(options));
  whenReady(() => assistant.mount());
  return assistant;
}

export function whenReady(fn: () => void): void {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  } else {
    fn();
  }
}

export default { init, Assistant, VERSION };

/** Bề mặt toàn cục do `dist/apus-assistant.js` dựng lên. Đây là cách duy nhất
 *  app dùng thư viện — không có bản npm để import. */
export interface ApusAssistantGlobal {
  readonly VERSION: string;
  /** Dựng trợ lý. Gọi lần thứ hai sẽ `update()` instance đang có. */
  init(options?: WidgetOptions): ApusAssistantApi;
  /** Instance đang chạy, hoặc null nếu chưa dựng. */
  readonly instance: ApusAssistantApi | null;
  /** Lấy instance, dựng nếu chưa có. */
  get(): ApusAssistantApi;
  /** Đường tắt hay dùng nhất từ nút Ask của app chủ. */
  open(context?: OpenContext): void;
  Assistant: typeof Assistant;
}

/** Hàng lệnh cho snippet đặt trước thẻ script. */
export interface ApusCommandQueue {
  (command: string, ...args: unknown[]): unknown;
  q?: unknown[][];
}

declare global {
  interface Window {
    ApusAssistant: ApusAssistantGlobal;
    apus: ApusCommandQueue;
  }
}
